import React, { Component } from "react";
import { logoutUser } from "../../actions/authActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";

class LoggedUser extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		userData: JSON.parse(localStorage.getItem('userData'))
    }
	
}
 
logoutUser=()=>{
	localStorage.removeItem('deeplinkRef');
	localStorage.removeItem('recordingStatus');
	//localStorage.removeItem('settingsInSession');
	
	let userEmail = '';		
	if ( JSON.parse(localStorage.getItem("userData")) )
		{
			userEmail = JSON.parse(localStorage.getItem("userData")).email;
		}
	localStorage.setItem('lastRememberedEmail', userEmail);	
	this.props.logoutUser();
}

updateUser=()=>{
	var storageData = JSON.parse(localStorage.getItem('userData'));
	
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axios.defaults.headers.common['Authorization'] = token;	
	axios.post(process.env.REACT_APP_API_URL +'/api/v1/session/getUserInfo').then(res => {
		storageData.firstName = res.data.responseData.firstName;
		storageData.lastName = res.data.responseData.lastName;
		storageData.image = res.data.responseData.image;
		
		this.setState({userData: storageData});
		localStorage.setItem('userData', JSON.stringify(storageData));
		this.props.updateAllProfileData();
	}).catch(err =>{});   
}

  render() {
	const userData = this.state.userData;
	  
	return (
		<div className="logged_user_content" onClick={this.logoutUser}>
			<div className="user_avatar_logged" style={{ backgroundImage: userData.image && userData.image.indexOf('.s3') > -1 ? "url("+userData.image+")" : "url(./images/user_avatar.svg)"}}></div>
			<div className="user_name_logged">{userData.firstName} {userData.lastName}</div>
			<div className="logout_btn"></div>
		</div>
    );
  }
}

LoggedUser.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  {logoutUser},
  null,
  {forwardRef: true}
)(LoggedUser);
